import React from 'react';
import SpinnerButton from '../SpinnerButton/SpinnerButton';
import { FaInfoCircle } from 'react-icons/fa';
import { t } from 'i18next';
import { DriveItEasyStatusEnum } from '../../api/models/Enums';
import { Button } from 'react-bootstrap';
import useTiassistoStore from '../../store/TiassistoStore';
import ToolTip from '../../components/Tooltip/Tooltip';
import './Tiassisto.scss'

interface DriveItEasyControlButtonProps {
  driveItEasyStatus: DriveItEasyStatusEnum;
  isLoading: boolean;
  dirty: boolean;
  updating: boolean;
  values: {
    driveItEasy: boolean;
    targa: string;
    telaio: string;
    dataFineContrattoDriveItEasy: string;
  };
  onClick: () => void;
}

const getLabel = (status: DriveItEasyStatusEnum): string => {
  switch (status) {

    case DriveItEasyStatusEnum.ATTIVO:
      return t('deactivate_drive_it_easy');
    case DriveItEasyStatusEnum.SOSPESO:
      return t('activate_drive_it_easy');
      default:
      return t('activate_drive_it_easy');
  }
};

const getButtonClass = (status: DriveItEasyStatusEnum): string => {
  switch (status) {
    case DriveItEasyStatusEnum.ATTIVO:
      return 'status-active';
    case DriveItEasyStatusEnum.SOSPESO:
      return 'status-suspended';
    default:
      return '';
  }
};

const getButtonVariant = (status: DriveItEasyStatusEnum): string => {
  switch (status) {
    case DriveItEasyStatusEnum.ATTIVO:
      return 'danger';
    case DriveItEasyStatusEnum.SOSPESO:
      return 'primary';
    default:
      return '';
  }
};

const getStyle = (status: DriveItEasyStatusEnum): React.CSSProperties => {
  if (status === DriveItEasyStatusEnum.SOSPESO) {
    return { backgroundColor: '#1fb0e5', borderColor: '#1fb0e5' };
  } else if (status === DriveItEasyStatusEnum.ATTIVO) {
    return { backgroundColor: '#dc3545', borderColor: '#dc3545' };
  }
  return {};
};

const DriveItEasyControlButton: React.FC<DriveItEasyControlButtonProps> = ({
  driveItEasyStatus,
  isLoading,
  dirty,
  updating,
  values,
  onClick,
}) => {
  const isDisabled = !values.driveItEasy || !values.targa || !values.telaio || !values.dataFineContrattoDriveItEasy || dirty || isLoading || updating;
  const { dieStatusData } = useTiassistoStore();
  const buttonClass = getButtonClass(driveItEasyStatus);
  const buttonVariant = getButtonVariant(driveItEasyStatus);
  const label = getLabel(driveItEasyStatus);

  return (
    <div style={{ position: 'relative' }}>

      {isDisabled && (
        <small id="info-die-required" className='text-muted me-2'>
          <FaInfoCircle size={18} />
          <ToolTip
            anchorId="info-die-required"
            content={t('info-die-required')}
            className="default"
            />
        </small>
      )}

      <Button
        id="toggleDie"
        onClick={onClick}
        disabled={isDisabled}
        // className={buttonClass}
        // variant={buttonVariant}
        style={getStyle(driveItEasyStatus)}
      >
        <SpinnerButton label={label} busy={isLoading} loadingText={t('loading')} />
      </Button>
    </div>


  );
};

export default DriveItEasyControlButton;

